module.exports = __webpack_public_path__ + "static/media/ic_reporting.c3611372.svg";